// Onay kutulu ağaçta (CheckTree) seçili satır: ayrıntı paneli kapanınca odak bu satıra döner
// (final review FE9) — panelin ✕ düğmesi kaybolunca odak gövdeye düşmesin.

export const SELECTED_TREE_ROW = '[data-check-tree] [role="treeitem"][data-selected="true"]';

/** Seçim kalkmadan ÖNCE çağrılır (seçim kalkınca `data-selected` da düşer). */
export function selectedTreeRow(root: ParentNode): HTMLElement | null {
  return root.querySelector<HTMLElement>(SELECTED_TREE_ROW);
}
